<!--  -->
<template>
  <div class="examSeason">
    <div class="content">
      <p>别忘了完善一下考试信息呦~</p>
      <div class="exam">
        <div
          :class="{ active: examNum.name === item.name }"
          v-for="(item, i) in examList"
          :key="i"
          @click="choose(item)"
        >
          <b> {{ item.name }}</b>
        </div>
      </div>
    </div>
    <button class="btn" :class="{active:examNum.name}" @click="submit">保存</button>
  </div>
</template>

<script>
import { reqNewUserRecord } from '@/api/login';

export default {
  components: {},
  data() {
    return {
      examNum: {},
      examList: [
       
        // {
        //   name: '24考研',
        //   key: 233,
        // },
        {
          name: '25考研',
          key:901,
        },
         {
          name: '26考研',
          key: 1117,
        },
        {
          name: '其他',
          key: 0,
        },
      ],
      point: false
    };
  },
  computed: {},
  watch: {},
  methods: {
    choose(item) {
      this.examNum = item;
    },
    async submit() {
      if (!this.examNum.name) {
        this.$toast('请选择考试标签');
        return;
      }
      if (this.examNum.key === 0) {
        this.close();
        return;
      }
      if(this.point)return;
      this.point=true;
      const { code, msg } = await reqNewUserRecord({
        company: 1,
        labelTreeIdList: [this.examNum.key],
        userCenter: false,
      });
      if (code === 0) {
        this.close();
      } else {
        this.$toast(msg);
      }
      this.point=false
    },
    close() {
      this.$emit('closeRegisterAfter', true);
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.examSeason {
  position: absolute;
  top: 480px;
  width: 100%;
}
.content {
  width: 542px;
  height: 336px;
  margin: 40px auto;
  padding: 0 40px;
  background: #fff;
  border-radius: 32px;
  box-shadow: 0 24px 16px -14px rgba(230, 189, 121, 0.3);
  > p {
    padding: 32px 0;
    color: #733d08;
    font-weight: 500;
    font-size: 28px;
    line-height: 40px;
    text-align: center;
  }
  .exam {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: flex-start;
    > div {
      width: 216px;
      margin-right: 30px;
      margin-bottom: 32px;
      text-align: center;
      border: 2px solid #d1d1d1;
      border-radius: 44px;
      > b {
        color: #333;
        font-weight: 400;
        font-size: 28px;
        line-height: 80px;
      }
    }
    > div:nth-child(2n) {
      margin-right: 0;
    }
    > div.active {
      background: #ff7f41;
      border:none;
      b {
        color: #ffff;
      }
    }
  }
}
.btn {
  display: block;
  width: 340px;
  margin: 0 auto;
  color: #fff;
  font-weight: 500;
  font-size: 32px;
  line-height: 88px;
  background: #ff7f41;
  border-radius: 44px;
  opacity: 0.5;
}
.btn.active{
  opacity: 1;
}
</style>
